export function fadeOutEffect(element, callBack) {
    let fadeEffect = setInterval(() => {
        if (!element.style.opacity) {
            element.style.opacity = 1;
        }
        if (element.style.opacity < 0.1) {
            clearInterval(fadeEffect);
            element.style.display = "none";
            if (callBack)
                callBack();
        } else {
            element.style.opacity -= 0.1;
        }
    }, 50);
}


// WEBPACK FOOTER //
// ./src/utils/animationutils.js